module.exports = __webpack_public_path__ + "fonts/MicrosoftYaHeiSemilight.7363862.ttf";